import type { FiltersValue } from '~features/dashboard-filters';

import type {
  ApplicationStatus,
  FindApplicationsRequestFilter,
  FindApplicationsRequestSort,
} from '~entities/application';

import type { SortingState } from '~shared/ui/dashboard-table';

import { endOfDay, startOfDay } from 'date-fns';

import { ColumnId } from './columns';

const orderMapping = {
  asc: 'ASC',
  desc: 'DESC',
} as const;

type ColumnsWithSort = Exclude<ColumnId, 'pos'>;

const columnToOrderByMapping: Record<
  ColumnsWithSort,
  FindApplicationsRequestSort['key']
> = {
  [ColumnId.AGREEMENT_ID]: 'agreementId',
  [ColumnId.STATUS]: 'applicationStatus',
  [ColumnId.DATE]: 'applicationTimestampUTC',
  [ColumnId.SALE_AMOUNT]: 'saleAmount',
  [ColumnId.DOWN_PAYMENT]: 'downPaymentAmount',
  [ColumnId.FINANCED_AMOUNT]: 'financedAmount',
} as const;

export function sortToParams({
  orderBy,
  direction,
}: SortingState): FindApplicationsRequestSort {
  return {
    key: columnToOrderByMapping[orderBy as ColumnsWithSort],
    order: orderMapping[direction],
  };
}

export function filtersToParams({
  period,
  posIds,
  merchantIds,
  statuses,
}: FiltersValue<ApplicationStatus>): FindApplicationsRequestFilter {
  const { startDate, endDate } = period ?? {};
  const dateTo = endDate ? new Date(endDate) : new Date();
  const dateFrom = startDate ? new Date(startDate) : new Date();

  return {
    dateTo: endOfDay(dateTo).toISOString(),
    dateFrom: startOfDay(dateFrom).toISOString(),
    merchantIds,
    pointOfSaleIds: posIds,
    applicationStatuses: statuses,
  };
}
